import { useMemo } from 'react'
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router'
import { useAuthStore } from 'shared/store/auth'
import { AppLayout, PhoneLayout } from './ui/layout/AppLayout'
import { Providers } from './ui/providers/Providers'
import { PHONE_ROLES, routesFor } from './ui/routes'
import { Login } from 'pages/login'
import { Settings } from 'pages/settings'

export function App() {
	const { isAuthenticated, user } = useAuthStore()
	const routes = useMemo(
		() => (isAuthenticated ? routesFor(user.role) : null),
		[isAuthenticated, user],
	)
	const Layout = PHONE_ROLES.includes(user.role) ? PhoneLayout : AppLayout

	const router = createBrowserRouter(
		routes
			? [
					{ element: <Layout />, children: routes },
					{
						// A path the role does not see lands on its first section.
						path: '*',
						element: <Navigate to={routes[0]?.path || '/'} />,
					},
				]
			: [
					{ path: '/login', element: <Login /> },
					{ path: '/settings', element: <Settings /> },
					{
						path: '*',
						element: <Navigate to='/login' />,
					},
				],
	)

	return (
		<Providers>
			<RouterProvider router={router} />
		</Providers>
	)
}

export default App
